import ArrowDownBounceIcon from "@/components/atoms/icons/ArrowDownBounceIcon";
import SHeading from "@/components/atoms/SHeading";
import { IMG_EBOOK } from "@/constants/imagesUrl";
import Image from "next/image";
import React from "react";
import { useTranslation } from "react-i18next";

const Ebooks = () => {
    const { t } = useTranslation();

    return (
        <div id="ebooks" className="w-full flex flex-col items-center p-8 pt-0 relative">
            <SHeading
                tAlign="center"
                text={t("home.ebooks.title")}
                className="text-center md:text-3xl text-xl"
            />
            <p className="mb-6 text-xl text-rose">{t("home.ebooks.subtitle")}</p>

            <div className="mb-6 w-full flex justify-center">
                <Image
                    src={IMG_EBOOK}
                    alt="Ebook"
                    width={500}
                    height={0}
                    className="w-auto rounded-lg shadow-lg"
                />
            </div>

            <p className="text-tblack text-md text-center max-w-3xl mb-6">
                {t("home.ebooks.description")}
            </p>
            <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-6">
                <ArrowDownBounceIcon />
            </div>
        </div>
    );
};

export default Ebooks;
